import {
  SUPPLIER_PO_TRANSACTION_DOC_NUMBER_FILTER,
  SUPPLIER_PO_TRANSACTION_DOC_NUMBER_INV_FILTER,
  SUPPLIER_PO_TRANSACTION_DOC_NUMBER_REF_FILTER,
} from "constants/ActionTypes";

const initialState = {
  docNumberFilter: "",
  docNumberInvFilter: "",
  docNumberRefFilter: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUPPLIER_PO_TRANSACTION_DOC_NUMBER_FILTER:
      return {
        ...state,
        docNumberFilter: action.payload,
      };
    case SUPPLIER_PO_TRANSACTION_DOC_NUMBER_INV_FILTER:
      return {
        ...state,
        docNumberInvFilter: action.payload,
      };
    case SUPPLIER_PO_TRANSACTION_DOC_NUMBER_REF_FILTER:
      return {
        ...state,
        docNumberRefFilter: action.payload,
      };
    default:
      return state;
  }
};

